import { FieldArgument } from './field-argument';
import { StateArgument } from './state-argument';
import { ContextArgument } from './context-argument';
export var ContextArgEnum;
(function (ContextArgEnum) {
    ContextArgEnum["EVENT"] = "$event";
    ContextArgEnum["FORM"] = "form";
    ContextArgEnum["ENTITY"] = "entity";
    ContextArgEnum["ACTION_NOTIFIER"] = "actionNotifier";
    ContextArgEnum["CATEGORY"] = "category";
    ContextArgEnum["ENTITY_ID"] = "entityId";
    ContextArgEnum["LANGUAGES"] = "languages";
    ContextArgEnum["CURRENT_LANGUAGE_ID"] = "currentLanguageId";
    ContextArgEnum["VALIDATIONS"] = "validations";
    ContextArgEnum["QUERY_PARAMS"] = "queryParams";
    ContextArgEnum["ITEM"] = "item";
    ContextArgEnum["ACTIONS"] = "actions";
    ContextArgEnum["CONTEXT_ENTITY"] = "contextEntity";
    ContextArgEnum["WORKFLOW_ACTIONS"] = "workflowActions";
    ContextArgEnum["TRANSIENT_FIELDS"] = "transientFields";
    ContextArgEnum["CONTROLLER_ID"] = "controlId";
    ContextArgEnum["LAYOUT_TYPE"] = "layoutType";
})(ContextArgEnum || (ContextArgEnum = {}));
export function FieldArg(name) {
    return new FieldArgument(name);
}
export function StateArg(name) {
    return new StateArgument(name);
}
export function ContextArg(arg) {
    return new ContextArgument(arg);
}
//# sourceMappingURL=dynamic-argument.type.js.map